import { render, staticRenderFns } from "./allOrder.vue?vue&type=template&id=9ecc206c&scoped=true&"
import script from "./allOrder.vue?vue&type=script&lang=js&"
export * from "./allOrder.vue?vue&type=script&lang=js&"
import style0 from "./allOrder.vue?vue&type=style&index=0&id=9ecc206c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ecc206c",
  null
  
)

export default component.exports